import {
  LogIn,
  Register,
  ResetPassword,
  ForgotPassword,
  TwoFactorAuthentication,
  OTPLogin,
  EmailConfirm,
  ResetOTP,
  ChangeEmail,
  MagicLink,
  MagicReceiver,
} from '../screens';
import config from "constants/config";

const initialRoutes = [
  {
    path: '/login',
    exact: true,
    component: LogIn,
    metadata: {
      title: "Login",
      description: "Welcome back. Paylix has everything you need to sell your digital goods. Log in to your account to manage your business.",
      image: `${config.CDN_PREVIEWS_URL}/login.png`
    }
  },
  {
    path: '/email',
    exact: true,
    noindex: true,
    component: TwoFactorAuthentication,
    metadata: {
      title: "Email",
      description: "Get back to your journey on Paylix: create new products, groups, categories, manage your orders and customers with just a click.",
      image: `${config.CDN_PREVIEWS_URL}/mfa.png`
    }
  },
  {
    path: '/otp/reset',
    exact: true,
    noindex: true,
    component: ResetOTP,
    metadata: {
      title: "OTP",
      description: "Get back to your journey on Paylix: create new products, groups, categories, manage your orders and customers with just a click.",
      image: `${config.CDN_PREVIEWS_URL}/reset-otp.png`
    }
  },
  {
    path: '/otp',
    exact: true,
    noindex: true,
    component: OTPLogin,
    metadata: {
      title: "OTP",
      description: "Get back to your journey on Paylix: create new products, groups, categories, manage your orders and customers with just a click.",
      image: `${config.CDN_PREVIEWS_URL}/reset-otp.png`
    }
  },
  {
    path: '/register',
    exact: true,
    component: Register,
    metadata: {
      title: "Register",
      description: "Everything you need to sell. Build your online store with Paylix’s all-in-one payments processing and Ecommerce solution for free, forever.",
      image: `${config.CDN_PREVIEWS_URL}/sign-up.png`
    }
  },
  {
    path: '/magic',
    exact: true,
    component: MagicReceiver,
    metadata: {
      title: "Magic Link",
      description: "Welcome back. Paylix has everything you need to sell your digital goods. Log in to your account to manage your business.",
      image: `${config.CDN_PREVIEWS_URL}/login.png`
    }
  },
  {
    path: '/magic-link',
    exact: true,
    component: MagicLink,
    metadata: {
      title: "Magic Link",
      description: "Welcome back. Paylix has everything you need to sell your digital goods. Log in to your account to manage your business.",
      image: `${config.CDN_PREVIEWS_URL}/login.png`
    }
  },
  {
    path: '/appsumo',
    exact: true,
    component: Register,
    metadata: {
      title: "Register with AppSumo",
      description: "Everything you need to sell. Build your online store with Paylix’s all-in-one payments processing and Ecommerce solution for free, forever.",
      image: `${config.CDN_PREVIEWS_URL}/sign-up.png`
    }
  },
  {
    path: '/password/reset',
    exact: true,
    noindex: true,
    component: ForgotPassword,
    metadata: {
      title: "Reset your Password on Paylix",
      description: "Have you forgot your password? Reset it here. Keep your email address close: you will receive an email for security purposes.",
      image: `${config.CDN_PREVIEWS_URL}/reset-password.png`
    }
  },
  {
    path: '/reset/:id',
    exact: true,
    noindex: true,
    component: ResetPassword
  },
  {
    path: '/validate/:code',
    exact: true,
    noindex: true,
    component: EmailConfirm
  },
  {
    path: '/change/email/:code',
    exact: true,
    noindex: true,
    component: ChangeEmail
  },
  {
    path: '/',
    pathTo: '/login',
    noindex: true,
    redirect: true
  },
]
export default initialRoutes;
